import React from "react";
import { QueryRenderer } from "@cubejs-client/react";
import { Spin } from "antd";
import NumberFormat from "react-number-format";
import cubejsApi from "../../../cubejsApiBQ";

const totalTableCartera = ({ resultSet, props }) => {
    var c = resultSet;
    Object.values(c.loadResponse.data[0]).unshift("Total");
    return (
        <table className="ant-table-fixed" style={{ width: "max-content" }}>
            <tfoot>
                <tr>
                    <td
                        style={{
                            width: "125px",
                        }}
                    >
                        <span
                            style={{
                                fontSize: "16px",
                            }}
                        >
                            Total
                        </span>
                    </td>
                    {Object.values(c.loadResponse.data[0]).map(
                        (element, index) => {
                            if (
                                element === null &&
                                (index === 1 || index === 3)
                            )
                                return (
                                    <td
                                        key={index}
                                        style={{
                                            width: "100px",
                                        }}
                                    >
                                        0.0%
                                    </td>
                                );
                            if (index === 5)
                                return (
                                    <td
                                        style={{
                                            width: "100px",
                                        }}
                                        key={index}
                                    >
                                        <NumberFormat
                                            value={element}
                                            decimalScale={1}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            prefix={""}
                                        />
                                    </td>
                                );
                            else if (index === 4)
                                return (
                                    <td
                                        style={{
                                            width: "110px",
                                        }}
                                        key={index}
                                    >
                                        <NumberFormat
                                            value={element}
                                            decimalScale={1}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            suffix={"%"}
                                        />
                                    </td>
                                );
                            else
                                return (
                                    <td
                                        style={{
                                            width: "125px",
                                        }}
                                        key={index}
                                    >
                                        <NumberFormat
                                            value={element}
                                            decimalScale={1}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            prefix={"$"}
                                        />
                                    </td>
                                );
                        }
                    )}
                </tr>
            </tfoot>
        </table>
    );
};

const renderChart = (Component, props) => ({ resultSet, error }) =>
    (resultSet && <Component resultSet={resultSet} props={props} />) || (
        <Spin />
    );

const TotalTableCartera = (props) => (
    <QueryRenderer
        query={{
            dimensions: [],
            timeDimensions: [],
            segments: [],
            measures: [
                "ResumenActividadCdt.valorVencimientoTotal",
                "ResumenActividadCdt.valorRenovaciones",
                "ResumenActividadCdt.valorNuevoTotal",
                "ResumenActividadCdt.valorCancelacionTotal",
                "ResumenActividadCdt.porcentajeRenovacion",
            ],
            filters: [
                {
                    dimension: "ResumenActividadCdt.mesCorte",
                    operator: "contains",
                    values: props.mesCorte !== "" ? [props.mesCorte] : [],
                },
                {
                    dimension: "ResumenActividadCdt.oficina",
                    operator: "contains",
                    values: props.oficina !== "" ? [props.oficina] : [],
                },
                {
                    dimension: "Usuarios.idCedula",
                    operator: "contains",
                    values: props.cedula !== "" ? [props.cedula] : [],
                },
            ],
        }}
        cubejsApi={cubejsApi}
        render={renderChart(totalTableCartera, props)}
    />
);

export default TotalTableCartera;
